var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.505,
    height: 16.505,
    viewBox: "0 0 16.505 16.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-calendar",
    d: "M8.98,6A2.991,2.991,0,0,0,6,8.98V19.525A2.991,2.991,0,0,0,8.98,22.5H19.525a2.991,2.991,0,0,0,2.98-2.98V8.98A2.991,2.991,0,0,0,19.525,6Zm0,1.375H19.525a1.6,1.6,0,0,1,1.6,1.6v.688H7.375V8.98A1.6,1.6,0,0,1,8.98,7.375Zm-1.6,3.668H21.129v8.482a1.6,1.6,0,0,1-1.6,1.6H8.98a1.6,1.6,0,0,1-1.6-1.6Zm2.98,1.834A1.146,1.146,0,1,0,11.5,14.023a1.146,1.146,0,0,0-1.146-1.146Zm3.9,0A1.146,1.146,0,1,0,15.4,14.023,1.146,1.146,0,0,0,14.252,12.877Zm3.9,0A1.146,1.146,0,1,0,19.3,14.023,1.146,1.146,0,0,0,18.149,12.877ZM10.355,17A1.146,1.146,0,1,0,11.5,18.149,1.146,1.146,0,0,0,10.355,17Zm3.9,0A1.146,1.146,0,1,0,15.4,18.149,1.146,1.146,0,0,0,14.252,17Z",
    transform: "translate(-6 -6)",
    fill: "#2a60bc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8b62b315e54f35396518ae4fe41a3191.svg";
export { ForwardRef as ReactComponent };